import type { ManualFragment } from '@/lib/types/datocms/graphql/generated'
import CtaTransparent from './ui/cta/CtaTransparent'

type Props = {
	manual: ManualFragment
}

export default function Manual({ manual }: Readonly<Props>) {
	return (
		<div className="flex items-center justify-between gap-4 py-4 lg:py-9 border-t overflow-hidden">
			<a
				className="flex gap-2 lg:text-lg"
				href={manual.asset?.url}
				target="_blank"
				rel="noreferrer"
				download
			>
				<span>{manual.text}</span>
				<span className="text-blue">{manual.linkText}</span>
			</a>

			<CtaTransparent
				cta={{
					__typename: 'NavigationItemRecord',
					id: '1',
					label: 'Download File',
					openInNewWindow: true,
					useExternalLink: true,
					externalLink: manual.asset?.url,
				}}
				variant="tertiary"
				download
				className="max-md:[&_.button-label]:hidden"
			/>
		</div>
	)
}
